export default __webpack_public_path__ + "static/media/Classwin - New icon_Check - White.1274af47.svg";